import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createStaticVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/google-meet.vue
var o = {
	name: "DtIconGoogleMeet",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--google-meet"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Google Meet",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("<path d=\"M1.5 8.5v7L4 16l2.5-.5v-7L4 8l-2.5.5Z\" fill=\"#1E88E5\"></path><path d=\"M18.5 12v7a1.5 1.5 0 0 1-1.5 1.5H6.5L6 18l.5-2.5h7V12l2.5-.5 2.5.5Z\" fill=\"#4CAF50\"></path><path d=\"M18.5 5v7h-5V8.5h-7L6 6l.5-2.5H17A1.5 1.5 0 0 1 18.5 5Z\" fill=\"#FBC02D\"></path><path d=\"M6.5 15.5v5H3A1.5 1.5 0 0 1 1.5 19v-3.5h5Z\" fill=\"#1565C0\"></path><path d=\"M6.5 3.5v5h-5l5-5Z\" fill=\"#E53935\"></path><path d=\"m19 12-.5 4.225-5-4.225 5-4.225L19 12Z\" fill=\"#2E7D32\"></path><path d=\"M23 5.055v13.89c0 .42-.49.655-.815.39l-3.685-3.11v-8.45l3.685-3.11a.501.501 0 0 1 .815.39Z\" fill=\"#4CAF50\"></path>", 7)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=google-meet.js.map